import type { SearchSummary } from '@tunasong/models'
import { dayjs, isTimeStamp } from '@tunasong/models'
import { useElementTypeMedia } from '@tunasong/plugin-lib'
import { isProfile } from '@tunasong/schemas'
import { getColorCSS, TagList, TunaBreadcrumbs, capitalize, Typography, ListItemIcon, ListItemText, ListItemSecondaryAction, MenuItem } from '@tunasong/ui-lib'
import type { MenuItemProps } from '@tunasong/ui-lib'
import type { JSX } from 'react'
import React from 'react'
export interface SearchResultListItemProps extends MenuItemProps {
  className?: string
  icon?: JSX.Element
  element: SearchSummary
  /** Show details */
  showDetails?: boolean
  /** Make the breadcrumbs active links */
  breadCrumbLinks?: boolean
  actions?: React.ReactElement | null
  ref?: React.Ref<HTMLElement>
}

export const SearchResultListItem = (props: SearchResultListItemProps) => {
  const { element, showDetails = true, actions, icon, breadCrumbLinks = true, ref, ...restProps } = props
  const { materialColor: color } = useElementTypeMedia(element.type)

  const details = element?.type ? (
    <Typography variant="caption">
      <TunaBreadcrumbs
        style={{ color: 'var(--tuna-palette-action-disabled)' }}
        parentChain={[element, ...(element.parentChain ?? [])].reverse()}
        variant="caption"
        showHome={false}
        showLeaf={false}
        activeLinks={breadCrumbLinks}
      />
      <span style={{ display: 'inline', color: getColorCSS(color) }}>{capitalize(element.type)}</span>.{' '}
      {isTimeStamp(element) ? `Updated ${dayjs(element.updatedAt).fromNow()}` : ''}.
      <TagList
        tags={element.tags}
        size="small"
      />
    </Typography>
  ) : null

  const name = isProfile(element) ? (element.name ?? element.email) : element.name
  return (
    <MenuItem ref={ref} {...restProps}>
      <ListItemIcon>{icon}</ListItemIcon>

      <ListItemText
        style={{
          overflow: 'hidden',
          paddingRight: 32,
        }}
        primary={
          <Typography
            style={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontWeight: 500,
            }}
          >
            {name}
          </Typography>
        }
        secondary={showDetails ? details : null}
      />

      <ListItemSecondaryAction>{actions}</ListItemSecondaryAction>
    </MenuItem>
  )
}

export default SearchResultListItem
